<template>
  <Toast />
  <Message v-if="!service_enabled" severity="warn">Mail service is disabled for this domain</Message>
  <Breadcrumb :home="bc_home" :model="bc_items" />
  <MailNavBar />
  
  <Card v-if="MailForwards" class="">
      <template #title>
        <Button icon="pi pi-plus" class="p-button-rounded p-button-primary" @click="openNewForwardModal" />
      </template>
        <template #content>
          
            <DataTable :value="MailForwards.forwards" class="p-datatable-sm" responsiveLayout="stack" @row-click="openForwardModal($event)" rowHover stripedRows selectionMode="single">
                <template #empty>
                  <div style="text-align: center;">No forwards found</div>
                </template>
                <Column field="address" header="Account"></Column>
                <Column field="destination" header="Destination"></Column>
                <Column header="Active" headerStyle="width: 100px; text-align: right">
                  <template #body="slotProps">
                    <i v-if="slotProps.data.is_enabled" style="color:var(--green-400)" class="pi pi-check-circle"></i>
                    <i v-else style="color:var(--orange-400)" class="pi pi-minus-circle"></i>
                  </template>
                </Column>
            </DataTable>
        </template>
  </Card>
  
  <Dialog header="New Forward" v-model:visible="displayNewForwardModal" :modal="true">
      <div class="new-forward">
          <form class="p-fluid" v-on:submit.prevent>
              <div class="p-field">
                  <div class="p-float-label">
                      <Dropdown v-model="forward.address" :options="MailAccounts.accounts" optionLabel="address" optionValue="address" placeholder="Select account" @change="" />
                      <small class="p-error" v-if="errors.address">{{ errors.address }}</small>
                  </div>
              </div>
              <div class="p-field">
                  <div class="p-float-label">
                      <InputText id="destination" v-model="forward.destination" v-on:keyup.enter="createForward" />
                      <label for="destination">Destination *</label>
                      <small class="p-error" v-if="errors.destination">{{ errors.destination }}</small>
                  </div>
              </div>
              <div class="p-field-checkbox">
                  <Checkbox id="is_enabled" :binary="true" v-model="forward.is_enabled"></Checkbox>
                  <label for="is_enabled">Enabled</label>
              </div>
              
          </form>
      </div>
      <template #footer>
        <Button label="Create" icon="pi pi-check-square" class="w-full" :loading="loading" @click="createForward"></Button>
      </template>
  </Dialog>
  <Dialog :header="forward.address" v-model:visible="displayForwardModal" :modal="true">
      <div class="new-forward">
          <form class="p-fluid" v-on:submit.prevent>
              <div class="p-field">
                  <div class="p-float-label">
                      <Dropdown v-model="forward.address" :options="MailAccounts.accounts" optionLabel="address" optionValue="address" placeholder="Select account" @change="" />
                      <label for="address">Account *</label>
                  </div>
              </div>
              <div class="p-field">
                  <div class="p-float-label">
                      <InputText id="destination" v-model="forward.destination" v-on:keyup.enter="saveForward"/>
                      <label for="destination">Destination *</label>
                      <small class="p-error" v-if="errors.destination">{{ errors.destination }}</small>
                  </div>
              </div>
              <div class="p-field-checkbox">
                  <Checkbox id="is_enabled" :binary="true" v-model="forward.is_enabled"></Checkbox>
                  <label for="is_enabled">Enabled</label>
              </div>
          </form>
      </div>
      <template #footer>
          <Button label="Delete" class="p-button-text p-button-danger" @click="deleteForward(forward)"></Button>
          <Button label="Update" icon="pi pi-check-square" :loading="loading" @click="saveForward"></Button>
      </template>
  </Dialog>
  <ConfirmDialog></ConfirmDialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getAttributes } from "../helpers/attributes.js"
import { convertErrors } from "../helpers/errors.js"
import MailNavBar from '../components/MailNavBar.vue'

export default {
  name: 'MailForwards',
  components: {
    MailNavBar
  },
  data () {
    return {
      forward: {
        id: '',
        address: '',
        destination: '',
        is_enabled: true
      },
      domain_name: 'test_domain',
      errors: {},
      displayForwardModal: false,
      displayNewForwardModal: false,
      domains: [],
      selectedDomain: null,
      loading: false,
      bc_home: {icon: 'pi pi-home', to: '/domains'},
      bc_items: [
          {icon: 'pi pi-spin pi-spinner'},
          {label: 'Mail', to: '/domains/'+this.$route.params.domain_id+'/mail'},
          {label: 'Forwards'}
      ],
      service_enabled: true,
    }
  },
  created: function () {
    this.GetMailForwards(this.$route.params.domain_id)
    this.GetMailAccounts(this.$route.params.domain_id)
  },
  computed: {
    ...mapGetters({ MailForwards: 'StateMailForwards', MailAccounts: 'StateMailAccounts', Domains: 'StateDomains' }),
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    current_domain() {
      return this.MailForwards
    }
  },
  watch: {
    current_domain (d) {
      if (d.domain && d.domain.name.length) {
        this.domain_name = d.domain.name
        this.bc_items = [
          {label: d.domain.name, to: '/domains/'+this.$route.params.domain_id},
          {label: 'Mail', to: '/domains/'+this.$route.params.domain_id+'/mail'},
          {label: 'Forwards'}
        ]

        const services = getAttributes(d.domain.attributes, 'services')

        if (services && services.mail && services.mail.enabled) {
          this.service_enabled = true
        }
        else {
          this.service_enabled = false 
        }
      }
    },
  },
  methods: {
    ...mapActions(['CreateMailForward', 'GetMailForwards', 'UpdateMailForward', 'DeleteMailForward', 'GetMailAccounts', 'GetDomains', 'GetDomainById']),
    async createForward () {
      this.loading = true
      this.errors = {}
      
      this.forward.domain_id = this.$route.params.domain_id

      this.CreateMailForward(this.forward)
        .then(response => {
          this.displayNewForwardModal = false
          this.forward = {id: '', address: '', destination: '', is_enabled: true}
          this.$toast.add({severity:'success', summary: 'Forward created', detail:response.data.address, life: 3000});
        })
        .catch(error => {
          this.errors = convertErrors(error.response.data)
        })
        .finally(() => this.loading = false)
    },
    async saveForward () {
      this.loading = true
      this.errors = {}
      
      this.UpdateMailForward(this.forward)
        .then(response => {
          this.displayForwardModal = false
          this.forward = {id: '', address: '', destination: '', is_enabled: true}
          this.$toast.add({severity:'success', summary: 'Forward updated', detail:response.data.address, life: 3000});
        })
        .catch(error => {
          this.errors = convertErrors(error.response.data)
        })
        .finally(() => this.loading = false)
    },
    async deleteForward(forward) {
      this.errors = {}
      
      this.$confirm.require({
          message: 'Are you sure you want to delete ' + forward.address + '?',
          header: 'Confirmation',
          icon: 'pi pi-exclamation-triangle',
          acceptClass: 'p-button-danger',
          accept: () => {
            this.loading = true

            this.DeleteMailForward(forward)
              .then(response => {
                this.displayForwardModal = false
                this.$toast.add({severity:'info', summary: 'Forward deleted', life: 3000});
              })
              .catch(error => {
                this.errors = error.response.data.errors
              })
              .finally(() => this.loading = false)
          },
          reject: () => {
              //callback to execute when user rejects the action
          }
      });


    },
    openNewForwardModal() {
      this.forward = {id: '', address: '', destination: '', is_enabled: true}
      this.errors = {}
      this.displayNewForwardModal = true
    },
    openForwardModal(e) {
      this.errors = {}
      const result = this.MailForwards.forwards.find( ({ id }) => id === e.data.id );
      Object.assign(this.forward, result)
      this.displayForwardModal = true
    }
  }
}
</script>

<style lang="scss" scoped>
.new-forward {
        form {
            margin-top: 2rem;
        }

        .p-field {
            margin-bottom: 1.5rem;
        }


}
</style>